import { t } from "@/i18n-js/instance";
import { Form } from "@circle-react-uikit/Form";
import { LinkInput } from "@circle-react-uikit/Form/LinkInput";

export const ContentEditor = () => (
  <div className="px-6">
    <Form.Item
      name="text"
      label={t("builder_ui.prop_type.text")}
      hideBorder
      hideDescription
    >
      <Form.Input name="text" />
    </Form.Item>
    <Form.Item
      name="href"
      label={t("builder_ui.prop_type.link")}
      hideBorder
      hideDescription
    >
      <LinkInput name="href" />
    </Form.Item>
  </div>
);
